import React, { Component } from 'react';
import { Spinner } from 'react-activity';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

export class VideoCallLoader extends Component {
    render() {
        if (!this.props.isInitialCallLoader) {
            return null;
        }

        return (
            <div className="flex w-full h-full fixed left-0 top-0">
                <div className="h-full w-full flex-col flex overflow-auto py-8 bg-UIBackground">
                    <div className="flex items-center justify-center h-full">
                        <div className="loader-container text-center">
                            <Spinner color="white" />
                            <div className="loader-text text-white">
                                {this.props.t('yourCallIsGettingInitiated')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const ConnectedVideoCallLoader = withLanguage(VideoCallLoader);

export default (props) => (
    <LanguageProvider>
        <ConnectedVideoCallLoader {...props} />
    </LanguageProvider>
);
